import { useEffect, useMemo } from "react";
import { useMatches, useParams } from "react-router-dom";
import { _T } from "../src/Localization";
import { useCompetition } from "../hooks/Competition";
import { useRoundPath } from "../hooks/Round";
export const DocumentTitle = () => {
    var _a, _b, _c, _d, _e;
    const matches = useMatches();
    const params = useParams();
    //
    // 1) Base translated title from handle.titleKey
    //
    const titleKey = (_b = (_a = [...matches]
        .reverse()
        .find(m => m.handle && m.handle.titleKey)) === null || _a === void 0 ? void 0 : _a.handle) === null || _b === void 0 ? void 0 : _b.titleKey;
    const translatedTitle = titleKey ? _T(titleKey) : null;
    //
    // 2) Competition / event name
    //
    const lookupId = params.competition_id ||
        params.event_id ||
        "";
    const [inputCompetition, event] = useCompetition(lookupId);
    const competitionOrEventName = (_e = (_d = (_c = inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_name) !== null && _c !== void 0 ? _c : event === null || event === void 0 ? void 0 : event.competition_name) !== null && _d !== void 0 ? _d : event === null || event === void 0 ? void 0 : event.event_name) !== null && _e !== void 0 ? _e : null;
    //
    // 3) Round path (auto-detect from params)
    //    Call useRoundPath UNCONDITIONALLY to keep hooks order stable.
    //
    const roundId = params.round_id;
    const competitionId = params.competition_id;
    const roundRef = roundId && competitionId && roundId !== "new"
        ? { competition_id: competitionId, round_id: roundId }
        : null;
    // useRoundPath expects a Round-ish object; we pass our minimal ref as any.
    const [pathString] = useRoundPath(roundRef);
    const roundTitle = roundRef && pathString ? pathString : null;
    //
    // 4) Effective page title:
    //    - If we are on a round -> use roundTitle
    //    - Else -> use translatedTitle
    //
    const pageTitle = roundTitle || translatedTitle;
    //
    // 5) Final fallback logic:
    //
    // has pageTitle:
    //   has name  → "pageTitle – name"
    //   no name   → "pageTitle"
    //
    // no pageTitle:
    //   has name  → "name - Vote4Dance"
    //   no name   → "Vote4Dance"
    //
    const finalTitle = useMemo(() => {
        if (pageTitle) {
            if (competitionOrEventName)
                return `${pageTitle} – ${competitionOrEventName}`;
            return pageTitle;
        }
        if (competitionOrEventName) {
            return `${competitionOrEventName} - Vote4Dance`;
        }
        return "Vote4Dance";
    }, [pageTitle, competitionOrEventName]);
    //
    // 6) Apply to document.title
    //
    useEffect(() => {
        document.title = finalTitle;
    }, [finalTitle]);
    return null;
};
